export default __webpack_public_path__ + "static/media/ServiceAnnotation.1a3be719.svg";